/** Represents the response from the geocoding service. */
export interface GeocodeResult {
  address_components: Array<{
    types: string[]
    short_name: string
    long_name: string
  }>
  geometry?: {
    location: {
      lat: () => number
      lng: () => number
    }
  }
  place_id?: string
  formatted_address?: string
}

/**
 * Extracts the zip code from Google geocoder results. This is necessary because
 * Google geocoding data may contain multiple levels of detail.
 *
 * @param {GeocodeResult[]} results - The array of geocode results
 * @param {number} resultIndex - The index in the results array to check
 * @returns {string | undefined} - The zip code, or undefined if not found
 */
export const getZipFromGeocoderResults = (
  results: GeocodeResult[],
  resultIndex: number,
): string | undefined => {
  const result = results[resultIndex]
  if (!result || !result.address_components) {
    return undefined
  }

  const addressComponent = result.address_components.find(component =>
    component.types.includes('postal_code'),
  )

  return addressComponent ? addressComponent.short_name : undefined
}
